//
//
//

export default {
  created () {
    var that = this
    var platcode = this.$route.params.platcode
    var code = this.$route.query.code
    var state = this.$route.query.state
    var url = '/weixin/accessin/' + platcode + '?code=' + code + '&state=' + state
    this.$axios.post(url, {}).then(function (res) {
      if (res.meta.success) {
        if (!that.$Utils.IsEmpty(res.data.openId)) {
          that.$UserUtils.setPlatCode(platcode);
          // 用openId登录
          that.toLoginByOpenId(res.data.openId, res.data.redirect_url);
        } else {
          window.location.href = res.data.redirect_url;
        }
      } else {
        sessionStorage.setItem('errmsg', res.meta.message)
        window.location.href = '/wx/exception/error'
      }
    })
  },
  methods: {
    toLoginByOpenId: function (openid, toUrl) {
      let that = this;
      let url = '/sso/doLoginByOpenId';
      that.$axiosSSO.post(url, null, {params: {openId: openid, loading: false}}).then(function (res) {
        if (res.meta.success) {
          that.$UserUtils.setToken(res.data)
          window.location.href = toUrl
        } else {
          sessionStorage.setItem('errmsg', res.meta.message)
          window.location.href = '/wx/exception/error'
        }
      })
    }
  },
  data () {
    return {
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/weixinAccessIn.vue